import { render } from "./BoundLocalSuppliersList.vue?vue&type=template&id=6047c495&scoped=true"
import script from "./BoundLocalSuppliersList.vue?vue&type=script&lang=js"
export * from "./BoundLocalSuppliersList.vue?vue&type=script&lang=js"

import "./BoundLocalSuppliersList.vue?vue&type=style&index=0&id=6047c495&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6047c495"]])

export default __exports__